import { orange as orangeMuiColor } from '@mui/material/colors';

const orange = {
  ...orangeMuiColor,
  C547: '#fdb022',
};

export default orange;
